import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

type StoreType = {
  isSettled: boolean;
  answerMap: AnswerMapType;
  setAnswerMap: (updater: (prev: AnswerMapType) => AnswerMapType) => void;
  resetAnswerMap: (answerMap: AnswerMapType) => void;
  setInputs: (id: string, inputs: string[]) => void;
  setSelectedId: (id: string, selectedId: string) => void;
};

export type AnswerMapType = Record<
  string,
  {
    assignmentProblemId: string;
    html: string;
    inputs: string[];
    selectedId?: string;
  }
>;

const useAnswerStore = create(
  persist<StoreType>(
    set => ({
      isSettled: false,
      answerMap: {},
      setAnswerMap: (updater: (prev: AnswerMapType) => AnswerMapType) =>
        set(state => ({
          answerMap: updater(state.answerMap),
        })),
      resetAnswerMap: (answerMap: AnswerMapType) =>
        set(state => ({
          ...state,
          answerMap,
        })),
      setInputs: (id: string, inputs: string[]) =>
        set(state => {
          // 다른 과제에서 넘어와 sessionStorage에 남은 stale answerMap이
          // resetAnswerMap으로 교체되기 전 호출되면 entry가 없을 수 있다.
          const prev = state.answerMap[id];
          if (!prev) return state;
          return {
            ...state,
            answerMap: {
              ...state.answerMap,
              [id]: { ...prev, inputs },
            },
          };
        }),

      setSelectedId: (id: string, selectedId: string) =>
        set(state => {
          const prev = state.answerMap[id];
          if (!prev) return state;
          return {
            ...state,
            answerMap: {
              ...state.answerMap,
              [id]: { ...prev, selectedId },
            },
          };
        }),
    }),
    {
      name: 'answer-store',
      storage: createJSONStorage(() => sessionStorage),
    },
  ),
);

export default useAnswerStore;
